var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-notifications.14fff681.png","uri@2x": __webpack_public_path__ + "icon-notifications.f0e53084.png","uri@3x": __webpack_public_path__ + "icon-notifications.1a742764.png",
    width: 20,
    height: 23
});